import { IExplain, IExplainValue } from "../types/dashboard";

// 获取指标注释
export const getExplainVal = (explainInfo: IExplain, key: string,locale: string, explainEn?: string, explainCn?: string) => {
  const pageExplain = locale === "en-US" ? (explainEn || explainCn) : (explainCn || explainEn);
  if (pageExplain) {
    return pageExplain;
  }
  const explainVal: IExplainValue = explainInfo?.[key];
  return locale === "en-US" ? (explainVal?.value_en || explainVal?.value_cn) : (explainVal?.value_cn || explainVal?.value_en);
};

// 获取指标中英文注释
export const getTips = (explainInfo: IExplain, key: string, explainEn?: string, explainCn?: string) => {
  const explainVal: IExplainValue = explainInfo?.[key];
  return {
    tipEn: explainEn? explainEn : explainVal?.value_en,
    tipCn: explainCn? explainCn : explainVal?.value_cn
  };
};
